import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

export type StaffManagementStaffType = {
  id?: number
  staff_id?: number
  driver_id?: number
  name?: string
  full_name?: string
  staff_name?: string
  staff_full_name?: string
  phone_number?: string
  staff_phone_number?: string
  driver_phone_number?: string
  plate_number?: string
  staff_plate_number?: string
  driver_plate_number?: string
  driver_full_name?: string
  [key: string]: unknown
}

export type AvailableStaffType = StaffManagementStaffType & {
  id: number
  name: string
  driver_id: number
  driver_full_name: string
  driver_phone_number: string
  driver_plate_number: string
}

type AvailableStaffResponseType = {
  data: StaffManagementStaffType[]
  pagination?: Record<string, unknown> | null
}

export const mapAvailableStaffToLegacy = (staff: StaffManagementStaffType): AvailableStaffType => {
  const staffId = staff.driver_id ?? staff.staff_id ?? staff.id ?? 0
  const staffName =
    staff.driver_full_name ??
    staff.staff_full_name ??
    staff.full_name ??
    staff.staff_name ??
    staff.name ??
    ''

  return {
    ...staff,
    id: staffId,
    name: staffName,
    driver_id: staffId,
    driver_full_name: staffName,
    driver_phone_number:
      staff.driver_phone_number ?? staff.staff_phone_number ?? staff.phone_number ?? '',
    driver_plate_number:
      staff.driver_plate_number ?? staff.staff_plate_number ?? staff.plate_number ?? '',
  }
}

export const getAvailableStaff = async (locationId: number | string, role = 'DRIVER') => {
  const response = await axiosInstanceApiGateway.Get<AvailableStaffResponseType, true>({
    url: '/staff-management/internal/v1/staff/get-by-filter',
    params: {
      location_id: locationId,
      role: role || 'DRIVER',
      sort: 'updated_at',
      direction: 'asc',
      is_active_role: true,
      status: 'Available',
    },
  })

  return {
    ...response,
    data: {
      ...response.data,
      data: (response.data.data ?? []).map(mapAvailableStaffToLegacy),
    },
  }
}

export const updateStaffAvailability = (staffId: number, isAvailable: boolean) =>
  axiosInstanceApiGateway.Put({
    url: `/staff-management/internal/v1/staff/${staffId}/availability`,
    data: {
      staff_id: staffId,
      is_available: isAvailable,
    },
  })
